import SwiperCore, { Pagination, Autoplay, EffectFade, EffectCreative, Thumbs } from 'swiper/core';

export const heroSlider = () => {
	SwiperCore.use([Pagination, Autoplay, EffectFade, Thumbs, EffectCreative]);
	new SwiperCore('.mySwiper3', {
		grabCursor: true,
		effect: 'creative',
		loop: true,
		speed: 1000,
		autoHeight: true,
		autoplay: {
			delay: 5000,
		},
		creativeEffect: {
			prev: {
				translate: ['-20%', 0, -1],
			},
			next: {
				translate: ['100%', 0, 0],
			},
		},
	});
};
